import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import LayoutMasterDetail from "layouts/LayoutMasterDetail";
import { StoreContext } from "shared/context/store-context";
import StudentSchoolItem from "./StudentSchoolItem";

const StudentSchoolsList = () => {
  const { t } = useTranslation();
  const itemType = "studentSchoolItem";
  const listName = "main_student_schools";

  const { studentSchools, DeleteSchool, InsertSchool, UpdateSchool } = useContext(StoreContext);

  const pageItems = studentSchools;

  let listColumns = [];
  listColumns.push({ field: "name", headerName: t("name"), width: 400 });
  listColumns.push({ field: "tag", headerName: t("tag"), width: 200 });

  return (
    <LayoutMasterDetail
      itemType={itemType}
      items={pageItems}
      listName={listName}
      listColumns={listColumns}
      SelectedItemComponent={StudentSchoolItem}
      NewItemComponent={StudentSchoolItem}
      DeleteItem={DeleteSchool}
      InsertItem={InsertSchool}
      UpdateItem={UpdateSchool}
      hideCreateNewItemWhenSelected={true}
    />
  );
};

export default StudentSchoolsList;
